import { isoAndUnixZodSchema } from "@@/shared/date-time/iso-and-unix";
import { metaContentZodSchema } from "@@/shared/meta-content/meta-content";
import { minMaxRangeZodSchema } from "@@/utilities/set-within-range";
import { z } from "zod";
import { resourcePriceZodSchema } from "../resource-price/resource-price";
import { resourceReferenceIdZodSchema } from "../resource-references/resource-reference-id";
import { resourceIdZodSchema } from "../resources/resource-id";
import type { BookableOption } from "./bookable-option";
import { bookableOptionIdZodSchema } from "./bookable-option-id";
import type { ManifestBookableOption } from "./manifest-bookable-option";
import { manifestFieldTypeZodSchema } from "./manifest-field-type";
import type { QuantityPickerBookableOption } from "./quantity-picker-bookable-option";

// QUICKFIXED CIRCULAR DEPENDENCY WARNING BY
// GATHERING THE ZOD SCHEMAS HERE IN THIS FILE,

const bookableOptionZodSchema: z.ZodSchema<BookableOption> = z.lazy(() =>
    z.union([
        quantityPickerBookableOptionZodSchema,
        manifestBookableOptionZodSchema,
    ]),
);

const quantityPickerBookableOptionZodSchema: z.ZodSchema<QuantityPickerBookableOption> =
    z.lazy(() =>
        z.object({
            _id: bookableOptionIdZodSchema,
            _type: z.literal("QUANTITY_PICKER_BOOKABLE_OPTION"),
            _createdAt: isoAndUnixZodSchema,
            resourceReferenceId: resourceReferenceIdZodSchema,
            resourceId: resourceIdZodSchema,
            overridesId: z.string().optional(),
            meta: metaContentZodSchema,
            minMax: minMaxRangeZodSchema,
            resourcePrice: resourcePriceZodSchema,
            default: z.number(),
            options: z.array(bookableOptionZodSchema),
        }),
    );

const manifestBookableOptionZodSchema: z.ZodSchema<ManifestBookableOption> =
    z.object({
        _id: bookableOptionIdZodSchema,
        _type: z.literal("MANIFEST_BOOKABLE_OPTION"),
        _createdAt: isoAndUnixZodSchema,
        resourceReferenceId: resourceReferenceIdZodSchema,
        resourceId: resourceIdZodSchema,
        meta: metaContentZodSchema,
        parentId: bookableOptionIdZodSchema,
        fields: z.array(manifestFieldTypeZodSchema),
    });
export {
    bookableOptionZodSchema,
    manifestBookableOptionZodSchema,
    quantityPickerBookableOptionZodSchema,
};
